import { useCallback, useEffect, useRef, useState } from 'react'
import { supabase, supabaseConfigured } from '../lib/supabaseClient'
import { useAuth } from '../contexts/AuthContext'
import { usePhoenixRefresh } from './usePhoenixRefresh'

const BUCKET = 'exercise-photos'

export function useExercise(id) {
  const { user } = useAuth()
  const [exercise, setExercise] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const initialLoadedRef = useRef(false)

  const fetchExercise = useCallback(async () => {
    if (!supabaseConfigured || !user || !id) {
      setLoading(false)
      return
    }
    if (!initialLoadedRef.current) setLoading(true)
    setError(null)
    const { data, error: err } = await supabase
      .from('exercises')
      .select('*')
      .eq('id', id)
      .maybeSingle()
    if (err) {
      setError(err.message)
      setLoading(false)
      return
    }
    if (!data) {
      setExercise(null)
      setLoading(false)
      return
    }
    let photoUrl = null
    if (data.machine_photo_url) {
      if (data.machine_photo_url.startsWith('http')) {
        photoUrl = data.machine_photo_url
      } else {
        const { data: pub } = supabase.storage.from(BUCKET).getPublicUrl(data.machine_photo_url)
        photoUrl = pub?.publicUrl || null
      }
    }
    setExercise({ ...data, photoUrl })
    setLoading(false)
  }, [id, user])

  useEffect(() => {
    fetchExercise()
  }, [fetchExercise])

  usePhoenixRefresh(fetchExercise)

  return { exercise, loading, error, refetch: fetchExercise }
}
